import { createContext } from 'react'

import { CalendarView } from '@/ui/MultiViewCalendar/Types'

type ContextValue = {
  userIds: string[]
  employeeIds: string[]
  canAssignVacation: boolean
  enableEmployeeSearchBar: boolean
  enableDepartmentPicker: boolean
  preferredView: CalendarView
  setPreferredView: (view: CalendarView) => void
  openPopupId: string | null
  setOpenPopupId: (id: string | null) => void
  enableTypeEditing: boolean
}

const defaultValue: ContextValue = {
  userIds: [],
  employeeIds: [],
  canAssignVacation: false,
  enableEmployeeSearchBar: false,
  enableDepartmentPicker: false,
  preferredView: 'month',
  setPreferredView: () => {},
  openPopupId: null,
  setOpenPopupId: () => null,
  enableTypeEditing: false,
}

const VacationCalendarContext = createContext(defaultValue)

export default VacationCalendarContext
